import { ServiceFieldType } from "@onlog-public/additional-services-types";
import {
  exportServiceFieldOptions,
} from "@pages/AdditionalServices/containers/additionServicesOptionsContext";
import {
  serviceContext$,
  serviceFilterAndOrderContext$,
  servicePropertyValueCacheContext$
} from "@pages/AdditionalServices/containers/bus";
import {ServiceData, SetUpServiceData} from "@pages/AdditionalServices/containers/methods/basket/types";
import {getCacheData} from "@pages/AdditionalServices/containers/methods/loadServiceDataCache";
import {
  ServicesServicePriceCalculationMutationProps
} from "@services/requests/servicesService/servicesServicesService/interface";

import { OptionsCache } from "../../services/optionsLoader/types";

/**
 * makeServiceData сформирует данные услуг, готовые для добавления в корзину.
 * Если передать ЦП вторым параметром, то будут сформированы данные только
 * под переданные ЦП. Если ЦП не переданы, то автоматически генерируются
 * данные для всех услуг в варианте.
 *
 * @param variantID
 * @param isAttachFilterData
 * @param partialServices
 */
const makeServiceData = (
  variantID: string,
  partialServices?: ServicesServicePriceCalculationMutationProps[]
): (ServiceData | SetUpServiceData)[] => {
  const state = serviceContext$.getValue()
  const propertiesCache = servicePropertyValueCacheContext$.getValue()
  const filterData = serviceFilterAndOrderContext$.getValue();

  const allServices = [
    ...state.VariantServices[variantID],
    ...state.VariantServices[variantID].map(s => s.additionServices ?? []).flat(1)
  ]

  const serviceOffers = partialServices ?? state.VariantsCalculationResult[variantID]
  const services: ServiceData[] = serviceOffers.map(offer => {
    const service = allServices.find(
      s => s.id === offer.serviceId
    )

    if (!service) {
      return undefined
    }

    return {
      service: {
        stateID: offer.stateID,
        service_id: parseInt(offer.serviceId),
        currency_id: parseInt(offer.currencyId),
        price_offer_result: offer.result,
        is_price_on_request: offer.isPriceByRequest,
      },
      ServiceData: service,
      ServiceDataCache: getCacheData(service, offer),
      ServiceFieldOptions: exportServiceFieldOptions(service.fields, {...state.FieldValues, ...state.VariantFieldValues[variantID]})
    }
  }).filter(s => !!s)

  if (services.length === 0) {
    return []
  }

  const overallCache: { [T in ServiceFieldType]: OptionsCache<any> } = {
    number: { isPartialLoading: false, cache: {} },
    switch: { isPartialLoading: false, cache: {} },
    hidden: { isPartialLoading: false, cache: {} },
    tax: { isPartialLoading: false, cache: {} },
    location: { isPartialLoading: false, cache: {} },
    handbook: { isPartialLoading: false, cache: {} },
    currency: { isPartialLoading: false, cache: {} },
    consulting_contractor: { isPartialLoading: false, cache: {} },
    inspection_contractor: { isPartialLoading: false, cache: {} },
    customs_contractor: { isPartialLoading: false, cache: {} },
    certification_contractor: { isPartialLoading: false, cache: {} },
    insurance_contractor: { isPartialLoading: false, cache: {} },
	package: { isPartialLoading: false, cache: {} },
	product: { isPartialLoading: false, cache: {} },
  };

  services.forEach((s) => {
    Object.keys(s.ServiceDataCache).forEach((key) => {
      const field = key as ServiceFieldType;
      const src = s.ServiceDataCache[field]?.cache;
      if (!src) return;
      const dest = overallCache[field].cache;

      Object.entries(src).forEach(([id, value]) => {
        if (!(id in dest)) {
          dest[id] = value;
        }
      });
    });
  });


  const variant = state.Variants.find(v => v.id === variantID)
  if (!variant) {
    return []
  }

  // noinspection UnnecessaryLocalVariableJS
  const setUpService: SetUpServiceData = {
    ...services[0],
    FieldValues: {...state.FieldValues, ...state.VariantFieldValues[variantID]},
    GlobalFieldOptions: exportServiceFieldOptions(
      [...state.FieldsToDisplay, ...variant.fields],
      {...state.FieldValues, ...state.VariantFieldValues[variantID]},
    ),
    IsSetupService: true,
    PropertyOptions: propertiesCache.Options[variantID],
    PropertyValues: state.PropertyValues[variantID],
    ServicesPath: state.ServicesPath,
    SelectedProductUUID: state.SelectedProductUUID,
    TemporaryStore: state.ServiceTemplateStore[variantID],
    Variant: variant,
    VariantFieldValues: state.VariantFieldValues[variantID],
	FilterData: { Variants: { ...filterData.Variants } }
  }

  services[0] = setUpService

  return services.map( s => ({ ...s, ServiceDataCache: overallCache }) )
}

export default makeServiceData